"use client";
import {EventStatus, IEventV2} from "@/app/dashboard/models/Event";
import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
import {Calendar, CircleAlert, MapPin} from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import FormattedDateTime from "@/app/common/components/FormattedDateTime";

export const EventCard = (props: { event: IEventV2; blurDataURL?: string }) => {
  const { event, blurDataURL } = props;

  return (
    <Link href={`/events/${event.id}`}>
      <Card className="p-3 rounded-2xl shadow-none hover:shadow-xl transition-shadow duration-500 bg-transparent border-none event-card">
        <CardHeader className="p-0 mb-2">
          <div className="relative w-full h-48">
            <Image
              src={event.image ? event.image : "/locations/london.jpg"}
              alt={event.name}
              sizes="(max-width: 768px) 100vw, 50vw"
              className="w-full h-full rounded-lg"
              width={400}
              height={200}
              placeholder="blur"
              priority={false}
              unoptimized={true}
              blurDataURL="/locations/london.jpg"
            />
            {event.status === EventStatus.SoldOut && (
              <div className="flex gap-1 items-center bg-stone-neutral-9/50 rounded-full backdrop-blur-sm py-1 px-2 absolute top-2 right-2">
                <CircleAlert strokeWidth={2} size={18} className="stroke-stone-neutral-0"/>
                <div className="text-base font-medium text-stone-neutral-0">Sold out!</div>
              </div>
            )}
          </div>
        </CardHeader>
        <CardContent className="p-0">
          <CardTitle className="text-lg font-medium text-midnight-teal mb-2 truncate tracking-normal">
            {event.name}
          </CardTitle>
          <div className="flex items-center text-gray-600 mb-1">
            <MapPin className="h-4 w-4 mr-2 shrink-0" />
            <span className="text-base grow truncate">
              {event?.location?.name ?? ""}
            </span>
          </div>
          <div className="flex items-center text-gray-600">
            <Calendar className="h-4 w-4 mr-2" />
            <span className="text-base grow">
              <FormattedDateTime event={event} format={"ddd, MMM D, YYYY h:mm A"} />
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
